module.exports = ".logo-header {\n  height: 50px; }\n\nmat-sidenav {\n  width: 240px !important; }\n"